import {FC, Fragment, useState, useEffect, useCallback} from "react";
import styled from "styled-components";
import {getGZLogo} from "modules/utils";
import {Footer} from "components/Footer";
import bg from "assets/images/secretPageBg.jpg";
import {useStore} from "modules/hooks";

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	flex-grow: 1;
	position: relative;
	min-height: 100vh;
	background: #151515 url(${bg}) no-repeat center;
	background-size: cover;
`;

const Wrapper = styled.div`
	display: flex;
	flex-grow: 1;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 40px;
	gap: 40px;
	width: 100%;
`;

const Logo = styled.img`
	max-width: 270px;
	width: 100%;

	@media (min-width: 769px) {
		width: 70%;
		max-width: 590px;
	}
`;

const Title = styled.div`
	font-weight: 700;
	font-family: "Hind", sans-serif;
	line-height: 120%;
	text-align: center;
	font-size: 16px;
	font-style: normal;

	button {
		display: inline;
		padding: 0;
		margin: 0;
		background: none;
		border: none;
		outline: none;
		font-weight: 700;
		font-family: "Hind", sans-serif;
		line-height: 120%;
		text-align: center;
		font-size: 16px;
		font-style: normal;
		color: #fff;
		cursor: text;
	}
`;

interface IProps {
	onPass: () => void;
}

export const SecretPage: FC<IProps> = ({onPass}) => {
	const {I18n} = useStore();
	const logo = getGZLogo(true);
	const [clickCounter, setClickCount] = useState(0);

	useEffect(() => {
		if (clickCounter > 10) {
			onPass();
		}
	}, [clickCounter, onPass]);

	const incrementClicks = useCallback(() => {
		setClickCount(clickCounter + 1);
	}, [clickCounter]);

	const replaceTextTranslation = (i18nValue: string, tag: string) => {
		const regex = new RegExp(`(.+)<${tag}>(.+)<\\/${tag}>(.+)?`, "gm");
		const execValue = regex.exec(i18nValue);

		if (execValue) {
			const [value, group1, group2, group3] = execValue;
			const hasGroups = [group1, group2, group3].every(Boolean);

			return hasGroups ? (
				<Fragment>
					{group1}
					<button onClick={incrementClicks}>{group2}</button>
					{group3}
				</Fragment>
			) : (
				value
			);
		}

		return i18nValue;
	};
	const secretTitleKey = "secret.title";
	const secretTitleTranslation = I18n.has(secretTitleKey)
		? I18n.t(secretTitleKey)
		: "THE NEW CFL TEAM PICKER IS COMING <text>SOON</text>...";

	return (
		<Container>
			<Wrapper>
				<Logo src={logo} alt="CFL Gamezone" />
				<Title>{replaceTextTranslation(secretTitleTranslation, "text")}</Title>
			</Wrapper>
			<Footer />
		</Container>
	);
};
